import { render } from "./MailComponent.vue?vue&type=template&id=43b98b9f"
import script from "./MailComponent.vue?vue&type=script&lang=js"
export * from "./MailComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Mail/MailComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43b98b9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43b98b9f', __exports__)) {
    api.reload('43b98b9f', __exports__)
  }
  
  module.hot.accept("./MailComponent.vue?vue&type=template&id=43b98b9f", () => {
    api.rerender('43b98b9f', render)
  })

}


export default __exports__